import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Card, Modal, Button, Typography } from 'antd'
import TokenList from '../../components/TokenList'
import { TokenForm } from '../../components/Forms'
import { TokenProvider, TokenConsumer } from '../../context/TokenContext'

export default class Token extends Component {

  state = {
    shouldReload: false
  }

  handleModalClose = (dispatchList: any, dispatchReset: any) => {
    const { history }: any = this.props
    const { shouldReload } = this.state

    history.replace('/organization/token')
    dispatchReset()

    if (shouldReload) {
      dispatchList({
        search: {
          action_key: 'GLOBAL_LOGIN'
        },
        options: {
          sort: ['-id']
        }
      })
    }
  }

  renderAdd = () => {
    const { permissions }: any = this.props
    if (!permissions.create) return null

    return (
      <Link to="token/add">
        <Button type="primary" shape="round">
          Create auth token
        </Button>
      </Link>
    )
  }

  render() {
    const { permissions, history, match: { params: { tokenUuid } }  }: any = this.props
    const modalVisible = tokenUuid && tokenUuid.length > 0

    return (
      <TokenProvider>
        <TokenConsumer>
          {({ fetching, error, email, password, token, tokens, pagination, requestTokenList, requestTokenFind, requestTokenGenerate, resetTokenGenerated }) => {

            // If we are adding a new entity and it did ok, we can do something here
            if (!fetching && !error && (email && password) && tokenUuid && tokenUuid === 'add') {
              history.push(`/organization/token/${email}`)

              // Flag to reload list when needed
              setTimeout(() => {
                this.setState({
                  shouldReload: true
                })
              }, 1000)
            }

            // If we are looking for details of certain entity, we need extra props in the form :P
            let addon: any = {
              permissions: permissions,
              history: history
            }
            if (tokenUuid && tokenUuid !== 'add') {
              addon = {
                ...addon,
                uuid: tokenUuid,
                data: token && token.uuid === tokenUuid ? token : null,
                regeneration: false,
                loadToken: requestTokenFind
              }
            }

            return (
              <Card title="List of authentication tokens" extra={this.renderAdd()}>
                <Typography.Text>Allows the support team to create authentication tokens to login into adopter and shelter accounts for limited amount of time (10 minutes) to troubleshoot and provide support.</Typography.Text>
                <TokenList loading={fetching} tokens={tokens} pagination={pagination} loadTokens={requestTokenList} />

                <Modal
                  title="Generate Token"
                  visible={modalVisible}
                  destroyOnClose={true}
                  footer={null}
                  onCancel={() => this.handleModalClose(requestTokenList, resetTokenGenerated)}
                >
                  <TokenForm {...addon} generatedUuid={email} generatedPassword={password} loading={fetching} error={error} dispatchSave={requestTokenGenerate} dispatchReset={resetTokenGenerated} />
                </Modal>
              </Card>
            )
          }}
        </TokenConsumer>
      </TokenProvider>
    )
  }
}
